import React from 'react';
import { Button } from '@mui/material';
import handlePdfExport from 'common/util/pdfExportUtil';

function ExportPdf({ sectionRefs, pageName }) {
  return (
    <Button
      data-html2canvas-ignore
      variant="outlined"
      onClick={() => handlePdfExport(sectionRefs, pageName)}
      sx={{ marginRight: '15px' }}
    >
      EXPORT PDF
    </Button>
  );
}

export default ExportPdf;
